import { types, actions } from './requests'
export const CREATEKIT_TYPES = {
    ...types('CREATEKIT'),
}
export const CREATEKIT_ACTIONS = {
    ...actions('CREATEKIT'),
}